module.exports = __webpack_public_path__ + "img/KH-邀请2.d56f8c50.png";